// Module
var code = "<h2 class=\"interiorSectionHeading\">Servicemembers Civil Relief Act (SCRA)</h2> <p>Servicemembers eligible for this benefit will have their interest rate capped on their eligible loans at 6% or lower, depending on your lender. Additionally, all costs and fees will be waived during their service.</p> ";
// Exports
export default code;